import React from 'react';
import {withTranslation} from "react-i18next";
import Layout from "../../layout/Layout";

const Teams = () => {

    return (
        <Layout>

        </Layout>
    )
}

export default withTranslation()(Teams)